<template>
  <v-dialog v-model="dialog" max-width="1000" scrollable>
    <template v-slot:activator="{ on }">
      <slot name="activator" :on="on"></slot>
    </template>
    <v-card>
      <v-card-title class="grey lighten-3 pa-2">
        <v-container fluid py-0>
          <v-row align="baseline">
            <v-icon class="draggable">mdi-drag</v-icon>
            <v-col>Add Taxes</v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="12" class="py-0 px-0">
              <v-card class="pa-3">
                <v-row>
                  <v-col xs="12" class="py-0">
                    <date-range-picker
                      :gt-date-from-string="validFrom"
                      :gt-date-to-string="validTo"
                      @onRangeSelected="onDateRangeSelected"
                      :outlined="outlinedInputs"
                    ></date-range-picker>
                  </v-col>

                  <v-col xs="12" class="py-0">
                    <gt-multi-select
                      label="Services"
                      :items="services"
                      select-all
                      v-model="selectedServices"
                      item-text="node.name"
                      item-value="node.id"
                      :show-selected="2"
                      :outlined="outlinedInputs"
                    ></gt-multi-select>
                  </v-col>
                  <v-col sm="1">
                    <list-visible-columns-and-filter
                      :visible-columns="visibleColumns"
                      :selectable-headers="selectableHeaders"
                      v-model="search"
                      @change="onVisibleColumnsChange"
                    ></list-visible-columns-and-filter>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-container fluid>
          <v-card outlined>
            <v-data-table
              v-model="selected"
              :headers="filteredHeaders"
              :items="taxItems"
              item-key="id"
              show-select
              v-bind="pagingOptions"
            >
              <template v-slot:item.name="{ item }">
                <template v-if="selected.find((i) => i.id == item.id)">
                  <v-text-field v-model="item.name" label="Name"></v-text-field>
                </template>
                <template v-else>{{ item.name }}</template>
              </template>
              <template v-slot:item.code="{ item }">
                <template v-if="selected.find((i) => i.id == item.id)">
                  <v-text-field v-model="item.code" label="Code"></v-text-field>
                </template>
                <template v-else>{{ item.code }}</template>
              </template>
              <template v-slot:item.percent="{ item }">
                <template v-if="selected.find((i) => i.id == item.id)">
                  <v-text-field
                    v-model="item.percent"
                    label="Percent"
                  ></v-text-field>
                </template>
                <template v-else>{{ item.percent }}</template>
              </template>
            </v-data-table>
          </v-card>

          <v-row v-if="debug">
            <v-col>taxes [{{ validTaxes }}] [{{ selected }}]</v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions class="grey lighten-4">
        <div class="flex-grow-1"></div>
        <v-btn color="warning" text @click="dialog = false">Cancel</v-btn>
        <v-btn color="primary" @click="onSave" :disabled="saveDisabled"
          >Save</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AgentGroupSelect from "../../shared/AgentGroupSelect";
import DateRangePicker from "../../shared/DatesRangePicker";
import ListVisibleColumnsAndFilter from "../../shared/ListVisibleColumnsAndFilter";
import GtMultiSelect from "../../shared/GtMultiSelect";
import { ListMixin } from "../../../../mixins/ListMixin";
import gql from "graphql-tag";
const TAXES_QUERY = gql`
  query($filter: TaxFilterType) {
    taxes(filter: $filter) {
      edges {
        node {
          id
          description
          code
          percentage
        }
      }
    }
  }
`;
export default {
  name: "add-taxes-dialog",
  props: {
    services: {
      type: Array,
      default: () => [],
    },
    serviceType: {
      type: String,
      default: () => "ACCOMMODATION",
    },
  },
  mixins: [ListMixin],
  components: {
    AgentGroupSelect,
    DateRangePicker,
    ListVisibleColumnsAndFilter,
    GtMultiSelect,
  },
  data() {
    return {
      debug: false,
      dialog: false,
      validFrom: "",
      validTo: "",
      selectedServices:
        this.services.length > 0 ? this.services.map((s) => s.node.id) : [],
      selected: [],
      agentGroup: "",
      visibleColumns: this.$store.getters.localSettings(this.$options.name, [
        "name",
        "code",
        "percent",
      ]),
      headers: [
        {
          text: "Name",
          value: "name",
          name: "name",
        },
        {
          text: "Code",
          value: "code",
          name: "code",
        },
        {
          text: "Percent",
          value: "percent",
          name: "percent",
        },
      ],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    taxItems() {
      return this.taxes && this.taxes.edges
        ? this.taxes.edges.reduce(
            (list, item) => [
              ...list,
              {
                id: item.node.id,
                name: item.node.description,
                code: item.node.code,
                percent: item.node.percentage,
              },
            ],
            []
          )
        : [];
    },
    validTaxes() {
      return this.validFrom != "" &&
        this.validTo != "" &&
        this.selectedServices.length > 0
        ? this.selectedServices.reduce(
            (taxes, serviceId) => [
              ...taxes,
              ...this.selected.map((tax) => ({
                serviceId,
                validFrom: this.validFrom,
                validTo: this.validTo,
                name: tax.name,
                code: tax.code,
                percent: Number(tax.percent),
              })),
            ],
            []
          )
        : [];
    },
    saveDisabled() {
      return this.validTaxes.length == 0;
    },
  },
  methods: {
    onDateRangeSelected(range) {
      this.validFrom = range.dateFrom;
      this.validTo = range.dateTo;
    },
    onSave() {
      this.dialog = false;
      this.$emit("save", [...this.validTaxes]);
    },
  },
  apollo: {
    taxes: {
      query: TAXES_QUERY,
      variables() {
        return {
          filter: {
            service_type: this.serviceType,
          },
        };
      },
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/taxes/AddTaxesDialog.vue